import { MAP_ID, ZOOM_LEVEL, STROKE_COLOR, STROKE_WIDTH, PLACE_MARK_ICON_COLOR, PLACE_MARK_PRESET } from '../../maps/config';
import getCoordinates, { destinationIdx, arrivalIdx } from "./coordinates";

/**
 * @function initYandexMap - рисует карту согласно маршруту
 * @param {YaMap} ymaps - глобальный объект предоставляющий доступ к карте
 * */

export default function initYandexMap(ymaps = {}) {
    if (!ymaps.hasOwnProperty('Map')) {
        setTimeout(initYandexMap, 100, window.ymaps);
        return;
    }

    const coords = getCoordinates(points);

    /** @var {YaMiniMap} miniMap */
    const miniMap = new ymaps.Map(MAP_ID, { center: [ points[0].latitude, points[0].longitude ], zoom: ZOOM_LEVEL });

    const routeCoordsConfig = {
        geometry: {
            type: 'LineString',
            coordinates: coords
        }
    };
    const routeCoordsStyles = {
        draggable: false,
        strokeColor: STROKE_COLOR,
        strokeWidth: STROKE_WIDTH
    };

    miniMap.geoObjects.add(new ymaps.GeoObject(routeCoordsConfig, routeCoordsStyles));

    for (let i = 0; i < points.length; i++) {
        const { latitude, longitude } = points[i];

        if (!(arrivalIdx <= i && destinationIdx >= i)) {
            continue;
        }

        miniMap.geoObjects.add(
            new ymaps.Placemark(
                [latitude, longitude],
                {balloonContent: points[i].name},
                {preset: PLACE_MARK_PRESET, iconColor: PLACE_MARK_ICON_COLOR}
            ),
        );
    }

    miniMap.setBounds(miniMap.geoObjects.getBounds());
}
